module.exports = __webpack_public_path__ + "front/img/login-kv.38e8216e.png";